import { Component, inject } from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ModuloService } from 'src/app/data/datasource/local/modulo.service';

/** Etiqueta del módulo activo arriba del menú lateral, con el color de acento del módulo. */
@Component({
  selector: 'app-modulo-etiqueta',
  standalone: true,
  imports: [TablerIconsModule],
  template: `
    @let m = moduloService.modulo();
    <div class="mod-tag" [style.--mod-color]="m.color" [attr.title]="m.nombre">
      <span class="mod-bar"></span>
      <i-tabler class="mod-icon" [name]="m.icono"></i-tabler>
      <span class="mod-text">
        <span class="mod-kicker">Módulo</span>
        <span class="mod-name">{{ m.nombre }}</span>
      </span>
    </div>
  `,
  styles: [
    `
      :host { display: block; padding: 4px 16px 6px; }
      .mod-tag {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 9px 12px 9px 14px;
        border-radius: 10px;
        overflow: hidden;
        background: color-mix(in srgb, var(--mod-color) 10%, transparent);
        animation: mod-in 0.28s ease-out;
      }
      .mod-bar {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 4px;
        background: var(--mod-color);
      }
      .mod-icon { width: 20px; height: 20px; color: var(--mod-color); flex: 0 0 20px; display: flex; }
      .mod-text { display: flex; flex-direction: column; line-height: 1.15; min-width: 0; }
      .mod-kicker { font-size: 10px; letter-spacing: 0.08em; text-transform: uppercase; opacity: 0.6; }
      .mod-name { font-size: 14px; font-weight: 700; color: var(--mod-color); white-space: nowrap; }

      /* Menú contraído: solo el ícono */
      :host-context(.sidebarNav-mini) { padding: 4px 8px 6px; }
      :host-context(.sidebarNav-mini) .mod-text { display: none; }
      :host-context(.sidebarNav-mini) .mod-tag { justify-content: center; padding: 9px 0; }

      @keyframes mod-in {
        from { opacity: 0; transform: translateX(-6px); }
        to { opacity: 1; transform: none; }
      }
    `,
  ],
})
export class ModuloEtiquetaComponent {
  moduloService = inject(ModuloService);
}
